/* eslint-disable */
import { FormikErrors, FormikProps, FormikTouched, getIn } from "formik";
import CustomTextField from "../../../../../shared/CustomTextField";
import { Dispatch, SetStateAction, memo } from "react";
import { AddressDetails } from "src/helpers/FormDetails/ProposalDetails/interfaces";
import { JointAddressDetails } from "src/helpers/FormDetails/JointLifeAddendum/interfaces";
import { useMutation } from "react-query";
import { pincodeCall } from "src/services/Master";
import CustomBackDrop from "src/shared/CustomBackDrop";
import store from "src/redux/store";
import { SET_TOAST_ERROR } from "src/redux/Actions/common";

interface Props {
  isAddressProposer: boolean;
  formik: {
    errors: FormikErrors<AddressDetails | JointAddressDetails>;
    touched: FormikTouched<AddressDetails | JointAddressDetails>;
    values: AddressDetails | JointAddressDetails;
    formikHandlers: FormikProps<any>;
  };
  savePincodeDataToStore: (data: any) => void;
  setIsPinCodeInvalid: Dispatch<SetStateAction<boolean>>;
  secondaryDetailsSchema?: any;
}
function SecondaryDetails({
  isAddressProposer,
  formik: {
    errors,
    touched,
    values,
    formikHandlers: { handleBlur, handleChange, setFieldValue }
  },
  savePincodeDataToStore,
  setIsPinCodeInvalid,
  secondaryDetailsSchema
}: Props) {
  const { isLoading, mutate: mutatePincode } = useMutation(["pincode"], pincodeCall, {
    retry: false,
    onSuccess: (response) => {
      if (!response.data) {
        setFieldValue("address.city", "");
        setFieldValue("address.state", "");
        store.dispatch(
          SET_TOAST_ERROR({
            error: true,
            duration: 6000,
            message: "Pincode mismatch. Retry with another value"
          })
        );
        setIsPinCodeInvalid(true);
      } else {
        setFieldValue("address.city", response.data?.city, false);
        setFieldValue("address.state", response.data?.state, false);
        setFieldValue("address.cityCode", response.data?.cityCode);
        setFieldValue("address.stateCode", response.data?.stateCode);
        savePincodeDataToStore(response.data);
        setIsPinCodeInvalid(false);
      }
    }
  });

  const handlePinCodeValidation = async (event: any) => {
    setFieldValue(event.target.name, event.target.value);
    if (!isNaN(+event.target.value) && event.target.value?.length === 6) {
      setIsPinCodeInvalid(false);
      mutatePincode(event.target.value);
    }
  };
  const renderFields = () => {
    return Object.entries(secondaryDetailsSchema || {}).map(([fieldName, config]: any) => {
      if (!config.visible) return null;

      const fullFieldName = `address.${fieldName}`;
      const isDisabled =
        config.disabled || (fieldName !== "city" && fieldName !== "state" && isAddressProposer);

      const isPincodeField = fieldName.toLowerCase() === "pincode";

      return (
        <CustomTextField
          key={fieldName}
          name={fullFieldName}
          label={config.label}
          value={getIn(values, fullFieldName) ?? config.defaultValue}
          onChange={isPincodeField ? handlePinCodeValidation : handleChange}
          handleBlur={handleBlur}
          error={getIn(errors, fullFieldName)}
          touched={getIn(touched, fullFieldName)}
          disabledField={isDisabled}
          requiredStar={config.required}
          maxLength={isPincodeField ? 6 : undefined}
        />
      );
    });
  };

  return (
    <>
      <CustomBackDrop open={isLoading} />
      <div className="space-y-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-x-10 gap-y-6">
          {renderFields()}
        </div>
      </div>
    </>
  );
}

SecondaryDetails.defaultProps = {
  isAddressProposer: false
};

export default memo(SecondaryDetails);
